import React, {Component} from 'react';
import List from '@material-ui/core/List';import ListItem from '@material-ui/core/ListItem';import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import {Badge} from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';


class License extends Component {
    state = {
        checked: [1],
    };

    handleToggle = (event, value) => {
        const {checked} = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked,
        });
    };


    render() {
        const {license} = this.props
        return (
            <List>
                {license.map((user, index) =>
                    <React.Fragment key={user.license_no}>
                        <ListItem button  onClick={event => this.handleToggle(event, user.id)}>
                        {/* <Avatar alt="Remy Sharp" src="https://via.placeholder.com/150x150"/> */}
                        <IconButton aria-label="Close" onClick={() => this.props.handleShowImage(user)}>
                            <i className="zmdi zmdi-collection-image"></i>
                        </IconButton>
                        <ListItemText className="br-break" primary={user.license_no} secondary={user.license_exp_date}/>
                        <Badge className="mr-4 mt-2 text-uppercase" color="success" pill>{user.license_name}</Badge>
                        <ListItemSecondaryAction>
                            <IconButton aria-label="Close" onClick={() => this.props.deleteLicense(user)}>
                                <CloseIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                        
                    </ListItem>
                    <Divider light/>
                    </React.Fragment>,
                )}
            </List>
        );
    }
}

export default License;


// WEBPACK FOOTER //
// ./app/routes/MasterVehicle/licenseVehicle.js